<template>
  <div class="header pb-6 d-flex align-items-center profile-header" :style="'position: absolute;top: 0px;left: 0px;width: 100%;z-index: -100;padding-top: 80px; background-image: url('+img+'); background-size: cover;'">
    <!-- Mask -->
    <span :class="'mask bg-'+color+' opacity-1'"></span>
    <!-- Header container -->
    <div class="container-fluid d-flex align-items-center">
      <div class="row">
        <slot>
          <div style="min-height: 250px">
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    color: {
      type: String,
      default: 'gradient-success', // default|light
      description: 'Background default color'
    },
    img: {
      type: String,
      default: '', // default|light
      description: 'Background image'
    }
  },
};
</script>
